import { render, staticRenderFns } from "./NewFooterCMSS.vue?vue&type=template&id=34b68206&scoped=true&"
import script from "./NewFooterCMSS.vue?vue&type=script&lang=js&"
export * from "./NewFooterCMSS.vue?vue&type=script&lang=js&"
import style0 from "./NewFooterCMSS.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewFooterCMSS.vue?vue&type=style&index=1&id=34b68206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b68206",
  null
  
)

export default component.exports